<template>
  <!-- 员工调岗 -->
  <div>
    <div v-show="Ygtg">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">员工调岗</div>
      <!-- 主体 -->
      <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
        <!-- 查询框 -->
        <div style="margin-left:3%">
          <div style="height:10px"></div>
          <div style="display:inline-block;margin-top:20px">
            <span>组织架构</span>
            <el-cascader v-model="condition.organize_ids" clearable
                style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
          </div>

        <!-- <div style="display:inline-block;margin-left:10px">
            <span>城市 </span>
            <el-select v-model="condition.staff.city_id" style="margin-left:10px;width:140px"
                :placeholder="postPlaceholder" clearable>
                <el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city" :value="item.city">
                </el-option>
            </el-select>
        </div> -->

        <div style="display:inline-block;margin-left:10px">
            <span>发起日期 </span>
            <el-date-picker style="width:150px;margin-left:10px" v-model="condition.create_time" type="date"
              placeholder="请选择" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
          <div style="display:inline-block;margin-top:20px">
						<span>姓名 </span>
						<el-input v-model="condition.staff.staff_name" style="margin-left:10px;width:150px"
							placeholder="请输入姓名">
						</el-input>
					</div>

          <div style="display:inline-block;margin-top:20px">
						<span>身份证号 </span>
						<el-input v-model="condition.staff.staff_card" style="margin-left:10px;width:150px"
							placeholder="请输入身份证号">
						</el-input>
					</div>

          <!-- <div style="display:inline-block;margin-left:10px">
            <span>状态 </span>
            <el-select v-model="condition.state" style="margin-left:10px;width:140px" placeholder="请选择" clearable>
          <el-option
            v-for="item in ztList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        </div> -->


          <!-- 按钮 -->
          <div style="display:inline-block;margin:20px 50px;float:right">
            <el-button type="goon" @click="Find">查询</el-button>
            <el-button type="goon" @click="Del(null)">删除</el-button>
            <el-button type="addbtn" @click="add">新增</el-button>
            <div style="display:inline-block;margin-left:220px">
						<download-excel class="export-excel-wrapper" :fields="download_excel" title="调岗人员清单"
									name="调岗人员清单.xls" :fetch="ExportForm"
									style="margin-left:-180px;top:100px">
							<el-button type="goon" style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
								导表</el-button>
						</download-excel>
					</div>
          </div>
        </div>

        <!-- 表格 -->
        <div style="margin:2% 3% 0 3%">
          <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}" :row-class-name="tableRowClassName"
            ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" height="540"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" label="序号" width="50">
              <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
            </el-table-column>
            <el-table-column align="center" label="组织架构" width="300">
				<template slot-scope="scope">
					{{$globals.group_name + "/" + scope.row.staff.range}}
				</template>
			</el-table-column>
            <el-table-column prop="staff.city_id" align="center" label="城市"></el-table-column>
            <el-table-column prop="staff.staff_name" align="center" label="调岗人"></el-table-column>
            <!-- <el-table-column prop="staff.post_name" align="center" label="现岗位"></el-table-column> -->
            <el-table-column prop="post_name" align="center" label="目标岗位"></el-table-column>
            <!-- <el-table-column prop="staff.nowSalary" align="center" label="现薪酬"></el-table-column> -->
            <el-table-column prop="target_salary" align="center" label="目标薪酬"></el-table-column>
            <el-table-column prop="create_time" align="center" label="发起日期" ></el-table-column>
            <el-table-column prop="transfer_explain" align="center" label="调岗说明"></el-table-column>
            <el-table-column prop="" align="center" label="状态" width=100>
              <template slot-scope="scope">
                <img src="../../../assets/待审批.png" v-show="scope.row.state === '0'" />
                <img src="../../../assets/已同意.png" v-show="scope.row.state === '1'" />
                <img src="../../../assets/stateImg/状态_已驳回.png" v-show="scope.row.state === '2'" />
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <img src="../../../assets/编辑.png" @click="bianji(scope.row)">
                <img src="../../../assets/删除.png" @click="Del(scope.row.id)">
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-row style="margin-top: 10px; text-align: center;">
            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
              layout=" prev, pager, next, jumper" :total="total">

            </el-pagination>
          </el-row>
        </div>

      </div>
    </div>
    
    <!-- 新增 -->
    <!-- <el-dialog
      :title="ruleForm.id == null || ruleForm.id == '' ? '添加' : '修改'"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :center="true"
      :modal-append-to-body="false"
      modal="false"
      :before-close="handleClose">
      <add ref="adds" v-show="showadd"></add> 
    </el-dialog> -->
    <add ref="adds" v-show="showadd" :organizeList="organizeList"></add>
  </div>
</template>

<script>
import add from './Ygtg_add.vue';
import axios from 'axios';
export default {
  components: {
    add: add,
  },
  data() {
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
			return organizeList.data;
		};
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      tableData: [],
      staffList: [],
      // dialogVisible: false,
      ruleForm: {
        post_name:'',
        target_salary:'',
        create_time:'',
        transfer_explain:'',
        state:'',
        staff_id:'',
        post_id:'',
        project_id:'',
        organize_temporary_ids:[],
        target_organize_name:'',
        staff:{
          staff_card:'',
          nowSalary:'',
          company_name: '',
          modular_name: '',
          city_id: '',
          project_name: '',
          staff_name: '',
          post_name: '',
        },
        gwlist:[],
        examineDetailsList: [],
      },

      download_excel: {
				    "组织架构": "staff.range",
				    "调岗人": "staff.staff_name",
				    "目标岗位": "post_name",
				    "目标薪酬": "target_salary",
				    "发起日期": "create_time",
            "调岗说明": "transfer_explain",
				},
      // 权限
      Ygtg: true,
      showadd: false,
      ids: [],
      //条件
      condition: {
		  organize_ids: [],
        post_name:'',
        target_salary:'',
        create_time:'',
        transfer_explain:'',
        state:'',
        staff:{
          company_name: '',
          modular_name: '',
          city_id: '',
          project_name: '',
          staff_name: '',
          post_name: '',
          nowSalary: '',
        }
      },
      ztList:[{
          value: '0',
          label: '待审批'
        }, {
          value: '1',
          label: '已同意'
      }, {
          value: '2',
          label: '已驳回'
      }],

      //回显查询岗位
      project_ide:'',
	  
	  //组织架构数据
	  organizeList: [],
	  
	  //级联下拉配置
	  props: {
			lazy: true,
			async lazyLoad(node, resolve) {
				if (node.level === 0) {
					return resolve(await organizeFind('', 'group'));
				} else {
					resolve(await organizeFind(node.data.id, ''));
				}
			},
	      value: "id",
	      label: "organize_name",
	      children: "organizeList",
	      checkStrictly: true,
	      multiple: true,
	  },
    };
  },
  methods: {
    // 全选
    handleSelectionChange(e) {
        this.ids = [];
        e.forEach(item => {
        this.ids.push(item.id);
      });
    },
    // 弹窗
    // handleClose() {
    //     this.dialogVisible = false
    // },
    Return() {
				this.showadd = false;
				this.Ygtg = true;
				this.trash();
				this.Find();
			},
    // 新增
    add(){
      this.Ygtg = false;
			this.showadd = true;
    },
    async gwList() {
				var url = 'post/selectFind';
				var record = {
					organize_id: this.project_ide,
				};
        var res = await this.$globals.AxiosPost(url, record);
        this.ruleForm.gwlist = res.data;
		},
    // 操作编辑
    bianji(e) {
      this.trash();
      this.Ygtg = false;
      this.showadd = true;
      this.ruleForm.id = e.id;
      this.project_ide = e.project_id;
      this.gwList();
      this.ruleForm.staff_id = e.staff_id;
      this.ruleForm.post_id = e.post_id;
      this.ruleForm.staff_name = e.staff.staff_name;
      this.ruleForm.staff.post_name = e.staff.post_name;
      this.ruleForm.staff.staff_card = e.staff.staff_card;
      this.ruleForm.target_salary = e.target_salary;
      this.ruleForm.transfer_explain = e.transfer_explain;
      this.ruleForm.target_organize_name = e.target_organize_name;
      // debugger
      // this.ruleForm.examineDetailsList = e.examineDetailsList;
    },
    //查询
    async Find() {
		var temporary = [];
		this.condition.organize_ids.forEach(item => {
		    temporary.push(item[item.length - 1]);
		})
		var organize_ids = "";
		temporary.forEach(item => {
		    organize_ids += item + ",";
		})
		
      var url = 'StaffTransfer/selectAll';
      var record = {
        page_num: this.page_num,
        page_size: this.page_size,
        data_grouping: 'Ygtg',
        organize_ids: organize_ids,
        city_id: this.condition.staff.city_id,
        create_time: this.condition.create_time,
        state: this.condition.state,
        applicant_id:this.$globals.user.staff_id,
        staff_name:this.condition.staff.staff_name,
        staff_card:this.condition.staff.staff_card,
        applicant_id:this.$globals.user.staff_id,
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === '-2000') {
        this.$message.error('服务器未响应！请稍后重试');
      } else {
        var code = data.code;
        var data = data.data;
        if (code === '200') {
          this.tableData = data.list;
          this.total = data.total;
        } else {
          this.$message.warning('请求失败！请稍后重试');
        }
      }
    },

    // 导表
			async ExportForm(){
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'StaffTransfer/selectAlls';
				var record = {
					 data_grouping: 'Ygtg',
            organize_ids: organize_ids,
            city_id: this.condition.staff.city_id,
            create_time: this.condition.create_time,
            state: this.condition.state,
            applicant_id:this.$globals.user.staff_id,
            staff_name:this.condition.staff.staff_name,
            staff_card:this.condition.staff.staff_card,
            applicant_id:this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导表成功！文件下载中！");
							return data;
						}else{
							this.$message.success("没有可以导出的数据！");
							return null;
						}
						
					} else {
						this.$message.warning(data);
					}
				}
			},

    // 操作删除
    async Del(e) {
        var ids;
        if (e === null || e === "" || e === undefined) {
            if (this.ids === null || this.ids.length <= 0) {
                this.$message.warning("请先选择操作数据！");
                return false;
            }
            ids = this.ids;
        } else {
            ids = [e];
        }
        
        var url = "StaffTransfer/del";
        var record = {
            ids: ids,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === "-2000") {
            this.$message.error("服务器未响应！请稍后重试");
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.$message.success(data);
                this.trash();
                this.Find();
            } else {
                this.$message.warning(data);
            }
        }
    },
    
    //分页
    handleCurrentChange(val) {
      this.page_num = val;
      this.Find();
    },
    //清除数据
    trash() {
      this.ruleForm.id = '';
      this.ruleForm.target_salary = '';
      this.ruleForm.post_name = '';
      this.ruleForm.create_time = '';
      this.ruleForm.transfer_explain = '';
      this.ruleForm.state = '';
      this.ruleForm.staff_id = '';
      this.ruleForm.post_id = '';
      this.ruleForm.staff.staff_card = '';
      this.ruleForm.staff.nowSalary = '';
      this.ruleForm.staff.company_name = '';
      this.ruleForm.staff.modular_name = '';
      this.ruleForm.staff.city_id = '';
      this.ruleForm.staff.project_name = '';
      this.ruleForm.staff_name = '';
      this.ruleForm.staff.staff_name = '';
      this.ruleForm.staff.post_name = '';
      this.ruleForm.organize_temporary_ids = [];
      this.ruleForm.examineDetailsList = [];
    },
	//初始化组织架构及下面的人
	async organizeFind() {
	    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
	        identification: "1",
	    });
	    this.organizeList = this.getTreeData(organizeList.data);
	
	},
	getTreeData(data) {
	    // 循环遍历json数据
	    for (var i = 0; i < data.length; i++) {
	
	        if (data[i].organizeList.length < 1) {
	            // children若为空数组，则将children设为undefined
	            data[i].organizeList = undefined;
	        } else {
	            // children若不为空数组，则继续 递归调用 本方法
	            this.getTreeData(data[i].organizeList);
	        }
	    }
	    return data;
	}
  },
  async created() {
    // this.Find();
	  this.organizeFind();
  },
};
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006e4b;
  border-color: #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color: #05573d;
  color: #006e4b;
}
.el-button--goon {
  color: #fff;
  background-color: #006e4b;
  border-color: #006e4b;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color: #006e4b;
  background-color: #fff;
  border-color: #006e4b;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #006e4b;
  border-color: #006e4b;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #006e4b;
}
.el-checkbox__inner:hover {
  border-color: #006e4b;
}
.el-button--pic {
  color: #006E4B;
  background-color: #fff;
  border-color:  #006E4B;
  font-size: 10px;
  height:30px;
  width: 70px;
  padding: 10px;
}
.el-button--pic:focus,
.el-button--pic:hover {
  background: #fff;
  border-color:  #05573d;
  color: #006E4B;
}
</style>


// WEBPACK FOOTER //
// Ygtg.vue?a96b67e6